import React from "react";
import styles from "./style.module.scss";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";

const WhatWeDo = () => {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    return (
        <section className={`${styles["mainContainer"]}`}>
            <div>
                <h2>
                    {translate(
                        translations,
                        "several_partnerWithUsPage_WhoWeAreTitle",
                    )}
                </h2>
                <p>
                    {`${translate(
                        translations,
                        "several_partnerWithUsPage_WhoWeAreDescription",
                    )}`}
                </p>
            </div>
            <div>
                <h2>
                    {translate(
                        translations,
                        "several_partnerWithUsPage_WhatWeDoTitle",
                    )}
                </h2>
                <p>
                    {`${translate(
                        translations,
                        "several_partnerWithUsPage_WhatWeDoDescription",
                    )}`}
                </p>
            </div>
            <div>
                <h2>
                    {translate(
                        translations,
                        "several_partnerWithUsPage_HowWeDoItTitle",
                    )}
                </h2>
                <p>
                    {`${translate(
                        translations,
                        "several_partnerWithUsPage_HowWeDoItDescription",
                    )}`}
                </p>
            </div>
        </section>
    );
};

export default WhatWeDo;
